/* Haven Print Co. — Kids Shop quick buy: pick options, add the name, add to cart without leaving the page */
(function () {
  if (window.__ksQB) return;
  window.__ksQB = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var cache = {};
  var modal, panel, body, lastBtn, state;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function attr(s) { return esc(s).replace(/"/g, '&quot;'); }
  function money(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur || 'USD' }).format(cents / 100).replace(/\.00$/, ''); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300);
  }

  /* Same rules as the product page boxes: "*" = required, "Label | A, B" = dropdown, "[big]" = larger box */
  function parsePF(text) {
    var out = [];
    (text || '').split(/\r?\n/).forEach(function (raw) {
      var line = raw.trim(); if (!line) return;
      var f = { req: false, big: false, opts: null };
      if (line.charAt(0) === '*') { f.req = true; line = line.slice(1).trim(); }
      if (line.indexOf('[big]') > -1) { f.big = true; line = line.replace('[big]', '').trim(); }
      if (line.indexOf('|') > -1) {
        var parts = line.split('|');
        line = parts[0].trim();
        f.opts = parts[1].split(',').map(function (o) { return o.trim(); }).filter(Boolean);
      }
      f.label = line;
      out.push(f);
    });
    return out;
  }

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'ksqb';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="ksqb__scrim" data-ksqb-close></div>' +
      '<div class="ksqb__panel" role="dialog" aria-modal="true" aria-labelledby="ksqb-title" tabindex="-1">' +
      '<button type="button" class="ksqb__x" data-ksqb-close aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="ksqb__body"></div></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.ksqb__panel');
    body = modal.querySelector('.ksqb__body');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ksqb-close]')) { close(); return; }
      var pill = e.target.closest('[data-ksqb-pill]');
      if (pill) { state.sel[+pill.dataset.i] = pill.dataset.val; update(); return; }
      var step = e.target.closest('[data-ksqb-step]');
      if (step) {
        var q = body.querySelector('[data-ksqb-qty]');
        q.value = Math.max(1, Math.min(99, (+q.value || 1) + (+step.dataset.ksqbStep)));
        return;
      }
      var buy = e.target.closest('[data-ksqb-buy]');
      if (buy) { e.preventDefault(); submit(true); }
    });
    modal.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trap(e);
    });
  }

  function trap(e) {
    var f = panel.querySelectorAll('button:not([disabled]), a[href], input, select, textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(btn) {
    build();
    lastBtn = btn;
    var handle = btn.dataset.ksQb;
    body.innerHTML = '<div class="ksqb__loading"><span></span><span></span><span></span></div>';
    modal.hidden = false;
    document.documentElement.classList.add('ksqb-lock');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    panel.focus({ preventScroll: true });

    var p = cache[handle] ? Promise.resolve(cache[handle]) :
      fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (j) { cache[handle] = j; return j; });

    p.then(function (product) { render(product, btn); })
      .catch(function () { location.href = btn.dataset.url || (root + 'products/' + handle); });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ksqb-lock');
    setTimeout(function () { modal.hidden = true; body.innerHTML = ''; }, reduce ? 0 : 220);
    if (lastBtn) lastBtn.focus({ preventScroll: true });
  }

  function render(product, btn) {
    var cur = btn.dataset.currency;
    var fields = parsePF(btn.dataset.pf);
    var simple = product.variants.length === 1 && /default title/i.test(product.variants[0].title);
    var start = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    state = { product: product, cur: cur, sel: start.options.slice(), simple: simple, url: btn.dataset.url || product.url };

    var h = '<form class="ksqb__form" novalidate>';
    h += '<div class="ksqb__head"><div class="ksqb__thumb"><img alt="" src="' + attr(img(start.featured_image ? start.featured_image.src : product.featured_image, 300)) + '"></div>' +
      '<div class="ksqb__titles"><h2 id="ksqb-title">' + esc(btn.dataset.title || product.title) + '</h2>' +
      '<div class="ksqb__price" data-ksqb-price></div>' +
      '<div class="ksqb__note">Free personalization · Ships in 2–4 business days</div></div></div>';

    if (!simple) {
      product.options.forEach(function (opt, i) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var seen = {}, vals = [];
        product.variants.forEach(function (v) { var val = v.options[i]; if (!seen[val]) { seen[val] = 1; vals.push(val); } });
        h += '<fieldset class="ksqb__opt"><legend>' + esc(name) + ' <span data-ksqb-chosen="' + i + '"></span></legend><div class="ksqb__pills">';
        vals.forEach(function (val) {
          h += '<button type="button" class="ksqb__pill" data-ksqb-pill data-i="' + i + '" data-val="' + attr(val) + '" aria-pressed="false">' + esc(val) + '</button>';
        });
        h += '</div></fieldset>';
      });
    }

    if (fields.length) {
      h += '<div class="ksqb__pf"><div class="ksqb__pf-title">Make it theirs</div>';
      fields.forEach(function (f, n) {
        var id = 'ksqb-f' + n;
        h += '<label class="ksqb__field" for="' + id + '"><span>' + esc(f.label) + (f.req ? ' <b aria-hidden="true">*</b>' : ' <i>(optional)</i>') + '</span>';
        var common = ' id="' + id + '" data-label="' + attr(f.label) + '"' + (f.req ? ' data-req aria-required="true"' : '');
        if (f.opts) {
          h += '<select' + common + '><option value="">Choose…</option>' + f.opts.map(function (o) { return '<option>' + esc(o) + '</option>'; }).join('') + '</select>';
        } else if (f.big) {
          h += '<textarea rows="3"' + common + '></textarea>';
        } else {
          h += '<input type="text" autocomplete="off"' + common + '>';
        }
        h += '</label>';
      });
      h += '</div>';
    }

    h += '<p class="ksqb__err" role="alert" hidden></p>';
    h += '<div class="ksqb__actions">' +
      '<div class="ksqb__qty" aria-label="Quantity"><button type="button" data-ksqb-step="-1" aria-label="Fewer">−</button><input data-ksqb-qty type="number" min="1" max="99" value="1" inputmode="numeric" aria-label="Quantity"><button type="button" data-ksqb-step="1" aria-label="More">+</button></div>' +
      '<button type="submit" class="ksqb__add" data-ksqb-add><span>Add to cart</span></button></div>' +
      '<button type="button" class="ksqb__buy" data-ksqb-buy>Buy it now</button>' +
      '<a class="ksqb__more" href="' + attr(state.url) + '">See photos & full details →</a>';
    h += '</form>';
    body.innerHTML = h;
    update();
    var firstInput = body.querySelector('.ksqb__pf input, .ksqb__pf textarea, .ksqb__pf select');
    if (simple && firstInput && window.innerWidth > 900) firstInput.focus({ preventScroll: true });
  }

  function current() {
    var s = state.sel;
    return state.product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); })[0];
  }

  function update() {
    var s = state.sel, product = state.product;
    body.querySelectorAll('[data-ksqb-pill]').forEach(function (b) {
      var i = +b.dataset.i, val = b.dataset.val;
      b.setAttribute('aria-pressed', s[i] === val ? 'true' : 'false');
      var test = s.slice(); test[i] = val;
      var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
      b.classList.toggle('is-out', !ok);
    });
    body.querySelectorAll('[data-ksqb-chosen]').forEach(function (el) { el.textContent = s[+el.dataset.ksqbChosen] ? '· ' + s[+el.dataset.ksqbChosen] : ''; });
    var v = current();
    var add = body.querySelector('[data-ksqb-add]'), buy = body.querySelector('[data-ksqb-buy]');
    var price = body.querySelector('[data-ksqb-price]');
    if (v) {
      price.innerHTML = money(v.price, state.cur) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price, state.cur) + '</s>' : '');
      if (v.featured_image) { var t = body.querySelector('.ksqb__thumb img'); if (t) t.src = img(v.featured_image.src, 300); }
    }
    var ok = !!(v && v.available);
    add.disabled = buy.disabled = !ok;
    add.querySelector('span').textContent = ok ? 'Add to cart · ' + money(v.price, state.cur) : (v ? 'Sold out' : 'Pick another combo');
  }

  function renderSections(sections) {
    var parse = function (html, sel) { var n = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return n ? n.innerHTML : null; };
    var d = document.getElementById('Cart-Drawer');
    if (d && sections && sections['cart-drawer']) {
      var inner = parse(sections['cart-drawer'], '.cart-drawer');
      if (inner !== null) {
        d.innerHTML = inner;
        if (typeof CartDrawer !== 'undefined') {
          try { var cd = Object.create(CartDrawer.prototype); cd.container = d; cd.removeProductEvent(); cd.notesToggle && cd.notesToggle(); cd.termsCheckbox && cd.termsCheckbox(); } catch (e) { }
        }
      }
    }
    var toggle = document.getElementById('cart-drawer-toggle');
    if (toggle && sections && sections['cart-bubble']) {
      var count = parse(sections['cart-bubble'], '.thb-item-count');
      var target = toggle.querySelector('.thb-item-count');
      if (count !== null && target) target.innerHTML = count;
    }
  }

  function submit(buyNow) {
    var err = body.querySelector('.ksqb__err');
    err.hidden = true;
    body.querySelectorAll('.ksqb__field').forEach(function (f) { f.classList.remove('is-invalid'); });
    var v = current();
    if (!v || !v.available) { err.textContent = 'That combination isn’t available. Pick another option.'; err.hidden = false; return; }

    var props = {}, missing = [];
    body.querySelectorAll('[data-label]').forEach(function (el) {
      var val = (el.value || '').trim();
      if (val) props[el.dataset.label] = val;
      else if (el.hasAttribute('data-req')) missing.push(el);
    });
    if (missing.length) {
      missing.forEach(function (el) { el.closest('.ksqb__field').classList.add('is-invalid'); });
      err.textContent = 'Add their personalization first (boxes marked *).';
      err.hidden = false;
      missing[0].focus();
      return;
    }

    var qty = Math.max(1, +body.querySelector('[data-ksqb-qty]').value || 1);
    var btn = buyNow ? body.querySelector('[data-ksqb-buy]') : body.querySelector('[data-ksqb-add]');
    body.querySelectorAll('[data-ksqb-add],[data-ksqb-buy]').forEach(function (b) { b.disabled = true; });
    btn.classList.add('is-loading');

    var item = { id: v.id, quantity: qty };
    if (Object.keys(props).length) item.properties = props;
    var onCartPage = !!document.getElementById('Cart');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: buyNow || onCartPage ? undefined : 'cart-drawer,cart-bubble', sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: j.items ? j.items[0] : j } }));
        if (buyNow) { location.href = root + 'checkout'; return; }
        if (onCartPage) { location.reload(); return; }
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        btn.querySelector('span') && (btn.querySelector('span').textContent = 'Added!');
        renderSections(j.sections);
        setTimeout(function () {
          close();
          var d = document.getElementById('Cart-Drawer');
          var toggle = document.getElementById('cart-drawer-toggle');
          if (d && toggle) toggle.click(); else location.href = root + 'cart';
        }, reduce ? 0 : 450);
      })
      .catch(function (e) {
        btn.classList.remove('is-loading');
        body.querySelectorAll('[data-ksqb-add],[data-ksqb-buy]').forEach(function (b) { b.disabled = false; });
        err.textContent = (e && (e.description || e.message)) || 'Couldn’t add that. Please try again.';
        err.hidden = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ks-qb]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  });
})();
